import React, { Fragment, useState } from 'react'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCopyright,
    faPlus,
    faFileExcel,
    faDownload,
} from '@fortawesome/free-solid-svg-icons'

// services
import { saveMarcasImportar } from '../../Services/marcaService'
import { getTemplate } from '../../Services/reporteService'

// routes
import { withRouter } from 'react-router-dom'

// Sweet alert
import Swal from 'sweetalert2'

const AddMarcaImportar = ({ history }) => {
    const [file, setFile] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const handleDownloadTemplate = async () => {
        try {
            const template = await getTemplate('marcas')
            const byteCharacters = atob(template.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'template-marcas.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al descargar el template.',
                showConfirmButton: true,
            })
        }
    }

    const addArticuloSubmit = (e) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append('file', file)

        setIsLoading(true) // Bloquea la pantalla

        saveMarcasImportar(formData)
            .then(() => {
                Swal.fire({
                    title: 'Importación exitosa',
                    text: 'Se importaron las marcas correctamente.',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 2000,
                })
            })
            .catch(() => {
                Swal.fire({
                    title: 'Error',
                    text: 'No se pudieron importar las marcas, verifique los datos de su archivo',
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 2000,
                })
            })
            .finally(() => {
                setIsLoading(false) // Desbloquea la pantalla
            })
    }

    return (
        <Fragment>
            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#198754',
                    }}
                >
                    <div
                        className="spinner-border text-success mb-3"
                        role="status"
                    >
                        <span className="sr-only">Cargando...</span>
                    </div>
                    Importando marcas...
                </div>
            )}

            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCopyright} title={'Importar Marcas'} />
                </div>

                <div className="bg-gris p-4">
                    <form
                        onSubmit={addArticuloSubmit}
                        encType="multipart/form-data"
                    >
                        <div className="form-row justify-content-center">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputFile">
                                    Seleccione un archivo
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faFileExcel} />
                                    </span>
                                    <input
                                        type="file"
                                        id="inputFile"
                                        name="fileCSV"
                                        className="form-control"
                                        onChange={(e) =>
                                            setFile(e.target.files[0])
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="text-center mt-4">
                            <button
                                type="button"
                                className="btn btn-outline-primary mr-2"
                                onClick={handleDownloadTemplate}
                            >
                                <FontAwesomeIcon icon={faDownload} /> Plantilla
                            </button>
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                                disabled={!file || isLoading}
                                style={{
                                    cursor:
                                        !file || isLoading
                                            ? 'not-allowed'
                                            : 'pointer',
                                    opacity: !file || isLoading ? 0.6 : 1,
                                }}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Importar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddMarcaImportar)
